import Component from "@glimmer/component";

const AVATAR_IMAGE_SIZE = 36;

export default class WazeWikiPostHeader extends Component {
  get post() {
    return this.args.post;
  }

  get avatarUrl() {
    return (
      this.post.avatar_template?.replace(
        "{size}",
        (AVATAR_IMAGE_SIZE * 2).toString(),
      ) || ""
    );
  }

  get formattedDate() {
    return moment(this.post.created_at).format("LL");
  }

  get posterName() {
    return this.post.name || this.post.username;
  }

  <template>
    <a
      href={{this.post.usernameUrl}}
      class="trigger-user-card main-avatar"
      data-user-card={{this.post.username}}
    >
      <div class="wiki-post-meta-data-container">
        <img
          class="avatar"
          width={{AVATAR_IMAGE_SIZE}}
          height={{AVATAR_IMAGE_SIZE}}
          src={{this.avatarUrl}}
          loading="lazy"
          tabindex="-1"
          alt=""
        />
        <div class="wiki-post-meta-data-text-container">
          <wz-subhead-4>{{this.posterName}}</wz-subhead-4>
          <wz-caption>{{this.formattedDate}}</wz-caption>
        </div>
      </div>
    </a>
  </template>
}
